module.exports = __webpack_public_path__ + "static/media/GoogleSans-BoldItalic.90773b61.ttf";